/* @flow */
import Button from 'components/Button.jsx';
import Link from 'components/Link.jsx';
import React from 'react';

import cx from 'classnames';

import './styles/AddButton.scss';

class AddButton extends React.Component {
  static propTypes = {
    disabled: React.PropTypes.bool,
    highlight: React.PropTypes.bool,
    linkId: React.PropTypes.string,
    size: React.PropTypes.oneOf(['normal', 'large']),
  };

  static defaultProps = {
    size: 'normal',
  };

  render() {
    const { highlight, className, disabled, linkId, onClick, size, children, ...others } = this.props;

    return (
      <Link
        {...others}
        className={cx({
          AddButton: true,
          'AddButton-highlight': highlight,
        }, className)}
        disabled={disabled}
        eventElementName={linkId}
        onClick={onClick}>
        <Button
          {...others}
          id={linkId}
          className={'AddButton-action AddButton-' + size}
          level="secondary"
          shape="circle"
          disabled={disabled}>
          +
        </Button>
        {children}
      </Link>
    );
  }
}

export default AddButton;



// WEBPACK FOOTER //
// ./src/components/AddButton.jsx